<template>
  <div>
    <div v-if="loading">
      {{ $t("bodyprint_declined.table.loading") }}
    </div>
    <div v-else>
      <div v-if="items.length === 0">
        {{ $t("bodyprint_declined.table.no_data") }}
      </div>
      <div v-else>
        <table
          class="table-fixed w-full border-solid px-4 mt-3 data-table-right-section overflow-y-auto table-parent"
        >
          <thead>
            <tr>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{ $t("bodyprint_declined.table.headers.user") }}
              </th>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{ $t("bodyprint_declined.table.headers.created_at") }}
              </th>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{ $t("bodyprint_declined.table.headers.last_updated_at") }}
              </th>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{ $t("bodyprint_declined.table.headers.retailer_code") }}
              </th>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{ $t("bodyprint_declined.table.headers.status") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in items"
              :key="index"
              @click="handleItemClick(item)"
              v-bind:class="[
                'cursor-pointer hover:bg-gray-50',
                selectedItem && selectedItem.id === item.id
                  ? 'font-bold'
                  : 'font-normal',
                index === items.length - 1 ? '' : 'border-b'
              ]"
            >
              <td class="py-3 px-2 text-left text-sm">
                {{ item.user ? item.user.email : "-" }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ item.created_at }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ item.last_updated_at }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ item.retailer_code }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{
                  $t(`general.status.bodyprint.${item.status.toLowerCase()}`)
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BodyPrintDeclinedTable",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedItem: {
      type: Object,
      default: () => null
    }
  },
  methods: {
    handleItemClick(item) {
      this.$emit("item-selected", item);
    }
  }
};
</script>
